import { render } from "./DefaultHeader.vue?vue&type=template&id=15eb738e&scoped=true"
import script from "./DefaultHeader.vue?vue&type=script&lang=ts"
export * from "./DefaultHeader.vue?vue&type=script&lang=ts"

import "./DefaultHeader.vue?vue&type=style&index=0&id=15eb738e&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-15eb738e"

export default script